<template>
	<div class="ptrl-18-16 box-s" :class="{'pb-30': padShow }" id="nodes">
		  <div class="flexs ps_clock">
				<img class="wh_14_17 mr-10" src="../../assets/img/icon/clock.png" alt="">
				<div class="c1 fz-16" >
					<span>倒计时</span> <span style="color: transparent">11</span>  <span :class="{ c9: time == '已超时' }">{{time}}</span>
				</div>
			</div>
			<div v-for="(item, index) in list" :key="index">
				<div class="quest_header flexs mb-22" v-if="qusetNum == (index + 1)">
					<div class="c1 fz-16"> <span class="fz-28 fw-500">{{qusetNum}}</span> <span class="fw-500">/</span> <span class="c2">{{length}}</span> </div>

					<div v-if="item.question_type == 1" class="tag_class mt-12 ml-5 bg_ff c13">单选题</div>
					<div v-if="item.question_type == 2" class="tag_class mt-12 ml-5 bg_dc c12">多选题</div>
					<div v-if="item.question_type == 3" class="tag_class mt-12 ml-5 bg_ea c11">判断题</div>
				</div>
				<div class="fz-14 fw-500 c1 mb-22" v-if="qusetNum == (index + 1) && item.question_stem" v-html="item.question_stem"></div>
				<!-- 单选题 -->
				<ul class="fz-14 c1" v-if="qusetNum == (index + 1) && (item.question_type == 1)">
					<li class="flex bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{ 'tag_active': form[index].answer[0] === Object.keys(innerItem)[0] }" v-for="(innerItem, innerIndex) in item.prepare_option" :key="innerIndex" @click="getRadios(Object.keys(innerItem)[0])" >
						<div class="">{{Object.keys(innerItem)[0]}}.</div>
						<div class="ml-6" v-html="innerItem[Object.keys(innerItem)[0]]"></div>
					</li>
				</ul>

				<!-- 判断题 -->
				<ul class="fz-14 c1" v-if="qusetNum == (index + 1) && (item.question_type == 3)">
					<li class="flex bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{ 'tag_active': form[index].answer === 'true' }" @click="getDecide('true', item)" >
						<div class="">A.</div>
						<div class="ml-6" >正确</div>
					</li>

					<li class="flex bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{ 'tag_active': form[index].answer === 'false' }" @click="getDecide('false', item)" >
						<div class="">B.</div>
						<div class="ml-6" >错误</div>
					</li>
				</ul>
				

				<!-- 多选题 -->
				<ul class="fz-14 c1" v-if="qusetNum == (index + 1) && item.question_type == 2">
					<li class="flex bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{ 'tag_active': form[index].answer.indexOf(Object.keys(innerItem)[0]) != -1 }" v-for="(innerItem, innerIndex) in item.prepare_option" :key="innerIndex" @click="getCheckBox(Object.keys(innerItem)[0])" >
						<div class="">{{Object.keys(innerItem)[0]}}.</div>
						<div class="ml-6" v-html="innerItem[Object.keys(innerItem)[0]]"></div>
					</li>
				</ul>
			</div>
		<loading :loadFlag="loadFlag"></loading>
    <qusetBottom :questBtn="questBtn" :length="length" :cData="cData" :collectFalg="collectFalg" :qusetNum="qusetNum" @getQuest="getQuest" @collect="collect" @quertCard="quertCard" ></qusetBottom>
	</div>
</template>
<script>
  
	import { getGateLevelQuestion  } from '@/api/api'
	import loading from "@/components/loading"
	import {getShowPadding, downTime} from "@/utils/common.js";
	import qusetBottom from "@/components/qusetBottom.vue";
	export default {
		components: {
      qusetBottom,
			loading
		},
		data() {
			return {
				length: 0,//题目数量
				padShow: false, //是否展示底部30padding
				list: [], //每一页的题数据
				qusetNum: 1, //第几道题
				form: [], //提交数据
        number: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U","V", "W", "X", "Y", "Z"],
				collectFalg: false, //是否收藏
				cData:{
					question_id: '',
					model_type: 4,
					way: 2,
					base_id: ''
				},
				time: '',//倒计时时间
				timer: '',
				loadFlag: false,
				questBtn: true
			};
		},
		created() {
			this.cData.base_id = this.$route.query.id
			this.type = this.$route.query.type? 1: ''
			this.qusetNum = this.$route.query.qusetNum? Number(this.$route.query.qusetNum):1
			// 倒计时
			downTime(this)
			this.initData()
		},
		mounted(){
      this.padShow = getShowPadding()
		},
		watch: {
			qusetNum: {
				handler(newvalue, oldvalue){
					
          // const { question_type, answer } = this.form[newvalue - 1]

					// this.radioTag = question_type == 1? answer : ''
					// this.checkBoxTag = question_type == 2? (answer? answer : []) : []
					// this.isTag = question_type == 3? answer : ''

					// this.question_type = this.list[newvalue - 1].question_type
				  // this.questTitle = this.list[newvalue - 1].question_stem
				}
			}
		},
		methods: {
			async initData(){
				this.loadFlag = true
        const res = await getGateLevelQuestion({ gate_level_id: this.$route.query.id })
				this.loadFlag = false
				if(res.code == 1000){
          this.list = res.data.question
					this.length = this.list.length

					this.cData.question_id = this.list[this.qusetNum - 1].question_id
          this.collectFalg = this.list[this.qusetNum - 1].question_wrong_id == 0? false : true
					if(this.$route.query.form){
            this.form = JSON.parse(this.$route.query.form)
					} else {
            this.form = this.list.map(item => {
							let i = {}
							if(item.question_type == 2){
								i = { "question_id": item.question_id, "answer": [] }
							} else {
								i = { "question_id": item.question_id, "answer": "" }
							}
							return i
						})
					}
				} else {
					this.$toast(res.msg)
				}
			},

			// 单选题切换
			getRadios(data){
				this.form[this.qusetNum - 1].answer = [data]
				console.log(this.form)
			},
      
			// 判断题切换
			getDecide(data, item){
        this.isTag = data
				this.form[this.qusetNum - 1].answer = data
				console.log(this.form)
			},
      
			// 多选题切换
			getCheckBox(data){
				if(this.form[this.qusetNum - 1].answer.indexOf(data) == -1){
          this.form[this.qusetNum - 1].answer.push(data)
				} else {
					this.form[this.qusetNum - 1].answer.splice(this.form[this.qusetNum - 1].answer.indexOf(data), 1)
				}

			},
			// 上一页，下一页
			getQuest(type){
				document.body.scrollTop = document.documentElement.scrollTop = 0;
				if(type == '1'){
          this.qusetNum -= 1
				} else if (type == '2') {
          this.qusetNum += 1
				}
        
        this.cData.question_id = this.list[this.qusetNum - 1].question_id
				this.collectFalg = this.list[this.qusetNum - 1].question_wrong_id == 0? false : true
			},

			// 收藏
			collect(collectFalg){
				console.log(collectFalg)
        this.collectFalg = !collectFalg
				this.list[this.qusetNum - 1].question_wrong_id = this.collectFalg? 1: 0
			},
			// 查看答题卡
			quertCard(type){
				const form = JSON.stringify(this.form)
        this.$router.replace({path: '/passcard', query:{form, id: this.$route.query.id, gate_level_id: this.$route.query.gate_level_id,timer:this.timer,gate_level_user_id:this.$route.query.gate_level_user_id,time_limit: this.$route.query.time_limit } })
			}

		}
	};
</script>
<style lang="less" scoped>
ul li:last-child {
	margin-bottom: 0;
}
</style>
